export enum SIZES {
  EXTRA_EXTRA_SMALL_HEIGHT = 15,
  EXTRA_EXTRA_SMALL_WIDTH = 16,

  EXTRA_SMALL_HEIGHT = 20,
  EXTRA_SMALL_WIDTH = 21,

  SMALL_HEIGHT = 24,
  SMALL_WIDTH = 25,

  MEDIUM_HEIGHT = 40,
  MEDIUM_WIDTH = 41,

  LARGE_HEIGHT = 48,
  LARGE_WIDTH = 49,

  EXTRA_LARGE_HEIGHT = 52,
  EXTRA_LARGE_WIDTH = 53,
}
